import { MobileProjects_projects } from './types/MobileProjects';
import { IDataTableRow } from '../../../components/DataTable/types';

export const mapToTableData = (data: MobileProjects_projects[]) =>
  data.map<IDataTableRow>((v) => ({ id: v.id, data: v }));
